import { get } from "lodash"
import { createSelector } from "reselect"

const getIsSuperuser = state => state.user.isSuperuser
export const getMfaSecret = state => get(state, "modules.userProfile.mfaSecret")
export const getQrCode = state => get(state, "modules.userProfile.qrCode")
export const getCurrentDeviceId = state => get(state, "modules.userProfile.currentDeviceId")
export const getMfaDevices = state => get(state, "user.mfaDevices")

export const showEmailSubscriptions = createSelector(
  [getIsSuperuser],
  (isSuperuser) => {
    return !isSuperuser
  },
)
